"use client";

import { c as _c } from "react/compiler-runtime";
import * as seadn from "@opensea/seadn";
import { createContext, useContext } from "react";
const RenderImageContext = createContext({
  renderImage: DefaultRenderImage
});
export function RenderImageProvider(t0) {
  const $ = _c(5);
  const {
    children,
    renderImage: t1
  } = t0;
  const renderImage = t1 === undefined ? DefaultRenderImage : t1;
  let t2;
  if ($[0] !== renderImage) {
    t2 = {
      renderImage
    };
    $[0] = renderImage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <RenderImageContext.Provider value={t2}>{children}</RenderImageContext.Provider>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function useRenderImage() {
  return useContext(RenderImageContext);
}
export function DefaultRenderImage(t0) {
  const $ = _c(26);
  let boost;
  let fit;
  let format;
  let frameTime;
  let quality;
  let restProps;
  let size;
  let src;
  if ($[0] !== t0) {
    ({
      src,
      size,
      frameTime,
      fit,
      format,
      quality,
      boost,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = boost;
    $[2] = fit;
    $[3] = format;
    $[4] = frameTime;
    $[5] = quality;
    $[6] = restProps;
    $[7] = size;
    $[8] = src;
  } else {
    boost = $[1];
    fit = $[2];
    format = $[3];
    frameTime = $[4];
    quality = $[5];
    restProps = $[6];
    size = $[7];
    src = $[8];
  }
  if (!src) {
    let t1;
    if ($[9] !== restProps || $[10] !== size) {
      t1 = <img height={size} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" width={size} {...restProps} />;
      $[9] = restProps;
      $[10] = size;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    return t1;
  }
  let t1;
  if ($[12] !== boost || $[13] !== fit || $[14] !== format || $[15] !== frameTime || $[16] !== quality || $[17] !== restProps.height || $[18] !== restProps.width || $[19] !== size || $[20] !== src) {
    t1 = seadn.optimize(src, {
      height: restProps.height ?? size,
      width: restProps.width ?? size,
      frameTime,
      fit,
      format,
      quality,
      boost
    });
    $[12] = boost;
    $[13] = fit;
    $[14] = format;
    $[15] = frameTime;
    $[16] = quality;
    $[17] = restProps.height;
    $[18] = restProps.width;
    $[19] = size;
    $[20] = src;
    $[21] = t1;
  } else {
    t1 = $[21];
  }
  const resized = t1;
  let t2;
  if ($[22] !== resized || $[23] !== restProps || $[24] !== size) {
    t2 = <img height={size} src={resized} width={size} {...restProps} />;
    $[22] = resized;
    $[23] = restProps;
    $[24] = size;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  return t2;
}